// @flow
import styled from 'styled-components';
import type { Theme } from '../../../../../../types';

export default styled<any, Theme>('nav')`
  display: flex;
  justify-content: center;
  margin-top: 1rem;
  position: absolute;
  right: 0;
  left: 0;
`;
